export const EffectsArray: any[] = [];
